<template>
    <div class="animated fadeIn apInvoiceDetail notification-templates bgV2" v-bind:class="{'run-loading': loadingItem}">
        <b-row>
            <b-col md="12">
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button
                            @click="saveItem"
                            :loading="loading"
                            label="SAVE"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <gofix-card title=" " class="px-4" fullContent>
                            <b-row>
                                <b-col md="8">
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-form-dropdown
                                                :multiple="false"
                                                label="Trigger"
                                                vLabel="name"
                                                :clearable="false"
                                                :options="event_trigger_options"
                                                v-model="form.event_trigger"
                                                disabled
                                                required />
                                        </b-col>
                                        <b-col md="12">
                                            <gofix-form-input
                                                label="Title"
                                                v-model="form.title"
                                                required />
                                        </b-col>
                                        <b-col md="12">
                                            <template v-if="form.medium == 'email'">
                                                <TinymceEditor 
                                                    :init="editorInit"
                                                    v-model="form.content"/>
                                            </template>
                                            <template v-else>
                                                <gofix-form-input-textarea
                                                    class="mb-0"
                                                    :rows="20"
                                                    label="Content"
                                                    v-model="form.content" />
                                            </template>
                                        </b-col>
                                        <b-col md="12" class="mt-20">
                                            <b-row class="align-items-center">
                                                <b-col md="2" class="pr-0">
                                                    <div class="custom-checkbox-device white-space-nowrap">
                                                        <b-form-checkbox 
                                                            :value="true"
                                                            v-model="form.is_repeat"
                                                            name="checkbox-inline-repeat" >
                                                            Repeat every
                                                        </b-form-checkbox>
                                                    </div>
                                                </b-col>
                                                <b-col md="2">
                                                    <gofix-form-input-number
                                                        class="mb-0"
                                                        label="Hours"
                                                        v-model="form.repeat_hours"
                                                        :allowDecimal="false"
                                                        :required="form.is_repeat"
                                                        :show-icon-required="form.is_repeat"
                                                        :disabled="!form.is_repeat"/>
                                                </b-col>
                                                <b-col md="2"></b-col>
                                                <b-col md="2" class="pr-0 text-center"> Repeat end </b-col>
                                                <b-col md="4">
                                                    <b-row>
                                                        <b-col md="12" class="mb-10">
                                                            <b-row class="align-items-center">
                                                                <b-col md="4" class="">
                                                                    <div class="custom-checkbox-device white-space-nowrap">
                                                                        <b-form-checkbox-group
                                                                            :options="[
                                                                                { text: 'After', value: 'by time' },
                                                                            ]" 
                                                                            value-field="value"
                                                                            text-field="text"
                                                                            v-model="form.repeat_by"
                                                                            name="radio-inline-by" 
                                                                            :disabled="!form.is_repeat"
                                                                            @change="changeRepeatEnd"/>
                                                                    </div>
                                                                </b-col>
                                                                <b-col md="8" class="">
                                                                    <gofix-form-input-number
                                                                        class="mb-0"
                                                                        label="Times"
                                                                        v-model="form.repeat_end_times"
                                                                        :allowDecimal="false"
                                                                        :required="form.repeat_by && form.repeat_by == 'by time'"
                                                                        :show-icon-required="form.repeat_by && form.repeat_by == 'by time'"
                                                                        :disabled="!form.repeat_by || (form.repeat_by != 'by time')"/>
                                                                </b-col>
                                                            </b-row>
                                                        </b-col>
                                                        <b-col md="12">
                                                            <b-row class="align-items-center">
                                                                <b-col md="4" class="">
                                                                    <div class="custom-checkbox-device white-space-nowrap">
                                                                        <b-form-checkbox-group 
                                                                            :options="[
                                                                                { text: 'By', value: 'by date' },
                                                                            ]" 
                                                                            value-field="value"
                                                                            text-field="text"
                                                                            v-model="form.repeat_by"
                                                                            name="radio-inline-by" 
                                                                            :disabled="!form.is_repeat"
                                                                            @change="changeRepeatEnd"/>
                                                                    </div>
                                                                </b-col>
                                                                <b-col md="8" class="">
                                                                    <gofix-form-input-date
                                                                        v-model="form.repeat_end_datetime"
                                                                        popoverDirection="top"
                                                                        label="Date"
                                                                        :required="form.repeat_by && form.repeat_by == 'by date'"
                                                                        :show-icon-required="form.repeat_by && form.repeat_by == 'by date'"
                                                                        :disabled="!form.repeat_by || (form.repeat_by != 'by date')">
                                                                    </gofix-form-input-date>
                                                                </b-col>
                                                            </b-row>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="4">
                                    <div class="custom-checkbox-device flex-column mb-5">
                                        <b-form-radio-group 
                                            :options="[
                                                { value: 'email', text: 'Email' },
                                                { value: 'sms', text: 'SMS' },
                                                { value: 'push notification', text: 'Push Notification' },
                                                { value: 'in-app notification', text: 'In-app Notification' },
                                            ]" 
                                            value-field="value"
                                            text-field="text"
                                            v-model="form.medium"
                                            disabled
                                            name="radio-inline-medium" />
                                    </div>
                                    <div class="custom-checkbox-device flex-column mb-20">
                                        <b-form-checkbox v-model="form.active">Active</b-form-checkbox>
                                    </div>    
                                </b-col>
                                <b-col md="12">
                                    <h4 class="mb-20">RECIPIENT GROUP(S)</h4>
                                    <template v-for="(recipient,index) in form.recipient">
                                        <gofix-card :title="recipient.title">
                                            <template slot="gofixCard:right_header">
                                                <button v-if="index != 0" class="icon-button gofixIconButton gofixPositionTopRight" @click="removeRecipientGroup(index)">
                                                    <svg width="18" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 5H19" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M17 5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5H17Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M8 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M12 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </button>
                                            </template>
                                            <b-col md="12">
                                                <gofix-form-dropdown
                                                    :multiple="true"
                                                    label="Roles"
                                                    vLabel="name"
                                                    :clearable="false"
                                                    :options="RoleItems.data"
                                                    v-model="recipient.roles"
                                                    required />
                                            </b-col>
                                            <b-col md="12">
                                                <gofix-form-dropdown
                                                    :multiple="true"
                                                    label="Teams"
                                                    :filterable="true"
                                                    vLabel="group_name"
                                                    :clearable="false"
                                                    :options="teams.data"
                                                    v-model="recipient.teams"
                                                    required>
                                                    <template #gofixInput:dropdown:option="{ group_name }">
                                                        {{group_name}}
                                                    </template>
                                                    <template #gofixInput:dropdown:selected-option="{ group_name }">
                                                        {{group_name}}
                                                    </template>
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="12">
                                                <gofix-form-dropdown
                                                    label="Users"
                                                    :multiple="true"
                                                    @search="searchUser"
                                                    :filterable="false"
                                                    :required="true"
                                                    v-model="recipient.users"
                                                    :options="users.data">
                                                    <template #gofixInput:dropdown:option="{ name, email }">
                                                        {{name}} - {{email}}
                                                    </template>
                                                    <template #gofixInput:dropdown:selected-option="{ name, email }">
                                                        {{name}} - {{email}}
                                                    </template>
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="12">
                                                <gofix-form-dropdown
                                                    label="AddrBook"
                                                    @search="searchAddrbook"
                                                    :clearable="false"
                                                    :multiple="true"
                                                    :required="true"
                                                    :filterable="true"
                                                    vLabel="email"
                                                    v-model="recipient.addrbook"
                                                    :options="addrbook.data">
                                                    <template #gofixInput:dropdown:option="{ name, email }">
                                                        {{name}} - {{email}}
                                                    </template>
                                                    <template #gofixInput:dropdown:selected-option="{ name, email }">
                                                        {{name}} - {{email}}
                                                    </template>
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-row class="align-items-center pl-15 pr-15 mb-20">
                                                <b-col md="1"> Filtered by </b-col>
                                                <b-col md="11">
                                                    <div class="custom-checkbox-device">
                                                        <b-form-checkbox
                                                            v-model="recipient.filter_by_property" class="float-left">
                                                            <span>Property</span>
                                                        </b-form-checkbox>
                                                        <b-form-checkbox
                                                            v-model="recipient.filter_by_service" class="float-left">
                                                            <span>Service Category</span>
                                                        </b-form-checkbox>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </gofix-card>
                                    </template>
                                    <b-row>
                                        <b-col md="12" class="text-right mt-10">
                                            <gofix-button
                                                @click="addRecipientGroup"
                                                :loading="loading"
                                                v-if="addGroupStatus == true"
                                                label="Add Recipient Group"></gofix-button>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>
                    </template>
                    <template slot="gofixTab:attachment">
                        <gofix-attachment :Item="form" :attachable_type="'notification'" classCard="mb-0" />
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    // import Editor from '@tinymce/tinymce-vue';
    const Attachment = () => import('@/views/attachments/list')
    import TinymceEditor from '@/views/plugins/Editor.vue'
    import moment from 'moment';
    export default {
        name: "lmu-notification-detail",
        props: { },
        components: {
            // 'editor': Editor,
            Attachment,
            TinymceEditor
        },
        data () {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "attachment",
                        title: "Attachments",
                        active: false
                    }
                ],
                editorOption: {
                    theme: 'snow',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link'],
                        ]
                    },
                    placeholder: "Content"
                },
                editorInit: {
                    height: 400,
                    menubar: false,
                    content_style: "body {font-size: 11pt;}",
                    plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                    'table emoticons template paste help',
                    'code',
                    'preview'
                    ],
                    toolbar:
                        'code | preview | formatselect | fontsizeselect | fontselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        table  \
                        bullist numlist outdent indent | removeformat | help',
                    fontsize_formats: '8pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
                    font_formats: "Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Georgia=georgia,palatino; Helvetica=helvetica; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva;"
                },
                loadingItem: false,
                loading: false,
                addGroupStatus: true,
                form: {
                    event_trigger: null,
                    medium: 'email',
                    title: null,
                    content: null,
                    is_repeat: false,
                    repeat_hours: null,
                    repeat_by: null,
                    repeat_end_times: null,
                    repeat_end_datetime: null,
                    recipient: [],
                    attachments: [],
                    active: true
                },
                users: {
                    data: [],
                    timer: null,
                },
                teams: {
                    data: [],
                    timer: null
                },
                addrbook: {
                    data: [],
                    timer: null
                },
                event_trigger_options: [],
            }
        },
        created() {
            this.getItem()
            this.$store.dispatch("RoleController/getRoleItems",{
                filter : { }
            });
        },
        watch: {
            "form.is_repeat": function(val) {
                if(!val) {
                    this.form.repeat_hours = null
                    this.form.repeat_by = null
                    this.form.repeat_end_datetime = null
                    this.form.repeat_end_times = null
                }
            },
        },
        computed: {
            ...mapGetters({
                RoleItems: 'RoleController/RoleItems',
            })
        },
        methods: {
            async saveItem() {
                if(this.form.is_repeat && !this.form.repeat_hours) {
                    return this.$alertNotification('Hours is required', "danger");
                }

                if(this.form.repeat_by) {
                    if(this.form.repeat_by == 'by time' && !this.form.repeat_end_times) return this.$alertNotification('Times is required', "danger");
                    if(this.form.repeat_by == 'by date' && !this.form.repeat_end_datetime) return this.$alertNotification('Date is required', "danger");
                }

                for ( let i = 0 ; i <= 2 ; i++ ) {
                    if ( this.form.recipient[i] && this.form.recipient[i].users ) {
                        this.form.recipient[i].users = this.form.recipient[i].users.map(function(item) {
                            return {
                                id: item.id,
                                name: item.name,
                                email: item.email,
                            }
                        });
                    }
                    if ( this.form.recipient[i] && this.form.recipient[i].addrbook ) {
                        this.form.recipient[i].addrbook = this.form.recipient[i].addrbook.map(function(item) {
                            return {
                                id: item.id,
                                name: item.name,
                                email: item.email,
                            }
                        });
                    }
                    if ( this.form.recipient[i] && this.form.recipient[i].roles ) {
                        this.form.recipient[i].roles = this.form.recipient[i].roles.map(function(item) {
                            return {
                                id: item.id,
                                name: item.name,
                            }
                        });
                    }
                    if ( this.form.recipient[i] && this.form.recipient[i].teams ) {
                        this.form.recipient[i].teams = this.form.recipient[i].teams.map(function(item) {
                            return {
                                id: item.id,
                                group_name: item.group_name,
                            }
                        });
                    }
                }
                
                this.form.event_trigger_id = this.form.event_trigger.id
                
                this.loading = true;
                await this.$store.dispatch("NotificationTemplateController/saveItemLMU", this.form)
                .then(response => {
                    this.$alertNotification(this.$notificationV2('editing', 'notification_templates'));
                    getItem()
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                })
            },
            async getItem() {
                this.loadingItem = true;
                await this.$store.dispatch("NotificationTemplateController/getItem", this.$route.params.id)
                    .then(response => {
                        let recipient = []
                        recipient.push({...{ title: 'TO' }, ...response.to_recipient})
                        recipient.push({...{ title: 'CC' }, ...response.cc_recipient})
                        recipient.push({...{ title: 'BCC' }, ...response.bcc_recipient})

                        this.form = Object.assign(this.form, {
                            id: response.id,
                            contract_id: response.contract_id,
                            event_trigger: response.event_trigger,
                            medium: response.medium,
                            title: response.title,
                            content: response.content,
                            is_repeat: response.is_repeat,
                            repeat_hours: response.repeat_hours,
                            // repeat_by: response.repeat_by,
                            repeat_end_times: response.repeat_end_times,
                            repeat_end_datetime: response.repeat_end_datetime,
                            recipient: recipient,
                            attachments: response.attachments,
                            module_use: response.module_use,
                            active: response.active
                        })

                        if(this.form.repeat_end_datetime) {
                            this.form.repeat_by = 'by date'
                            this.form.repeat_end_datetime = moment(this.form.repeat_end_datetime).toDate();
                        }

                        if(this.form.repeat_end_times) {
                            this.form.repeat_by = 'by time'
                        }

                        if ( recipient.length == 3 ) {
                            this.addGroupStatus = false
                        }

                        this.getUsers()
                        this.getTeams()
                        this.getAddrbook()
                        this.getEventsTrigger()
                        
                        this.loadingItem = false;
                    })
                    .catch(error => {
                        console.log(error)
                        if(error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                            this.$alertNotification(error.response.data.error.message, "danger");
                        }
                        this.loadingItem = false;
                    })
            },
            getUsers(){
                this.loadingItem = true
                this.$store.dispatch("v2UserController/searchListUser", { page: 1, totalPage: 0, limit: 100, filters: { name: '', organization_isfm : true, client_contract_id: this.form.contract_id ? this.form.contract_id : null } })
                .then(result=>{
                    this.users.data = result.data
                    this.loadingItem = false
                })
                .catch(err => {
                    console.log(err);
                    this.loadingItem = false
                })
            },
            searchUser (search, loading){
                loading(true);
                if(this.users.timer) {
                    clearTimeout(this.users.timer);
                    this.users.timer = null;
                }
               this.users.timer = setTimeout(() => {
                    this.$store.dispatch("v2UserController/searchListUser", { page: 1, totalPage : 0, limit: 1000, filters: { name: search, or: true, email: search, organization_isfm : true, client_contract_id: this.form.contract_id ? this.form.contract_id : null }})
                        .then(response => {
                           this.users.data = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            addRecipientGroup(){
                let countRecipient = 0
        
                this.form.recipient.map(function(item) {
                    countRecipient++     
                });

                if ( countRecipient == 1 ) {
                    this.form.recipient.push({
                        title: 'CC',
                        roles: [],
                        teams: [],
                        users: [],
                        addrbook: [],
                        filter_by_property: false,
                        filter_by_service: false,
                    });
                    return;
                }

                this.form.recipient.push({
                    title: 'BCC',
                    roles: [],
                    teams: [],
                    users: [],
                    addrbook: [],
                    filter_by_property: false,
                    filter_by_service: false,
                });
                this.addGroupStatus = false
            },
            removeRecipientGroup(index){
                this.$delete(this.form.recipient, index);
                this.addGroupStatus = true
            },
            getTeams(){
                if ( this.form.contract_id ) {
                    this.loadingItem = true
                    this.$store.dispatch("UserGroupController/getItems", {
                        page: 1,
                        limit: -1,
                        filter: {
                            contract_id: this.form.contract_id
                        }
                    })
                    .then(response => {
                        this.teams.data = response.items
                        this.loadingItem = false
                    })
                    .catch(err => {
                        this.teams.data = []
                        this.loadingItem = false
                    })
                }
            },
            getAddrbook(){
                if ( this.form.contract_id ) {
                    this.loadingItem = true
                    this.$store.dispatch("LMUAddressBookController/getItems", {
                        page: 1,
                        limit: -1,
                        filter: {
                            contract_id: this.form.contract_id,
                            contact_name: 'LMU',
                        }
                    })
                    .then(response => {
                        this.addrbook.data = response.items.map(function(item) {
                            return {
                                id: item.id,
                                name: item.display_name,
                                email: item.email,
                            }
                        });
                        this.loadingItem = false
                    })
                    .catch(err => {
                        this.addrbook.data = []
                        this.loadingItem = false
                    })
                }
            },
            searchAddrbook (search, loading){
                loading(true);
                if(this.users.timer) {
                    clearTimeout(this.users.timer);
                    this.users.timer = null;
                }
               this.users.timer = setTimeout(() => {
                    this.$store.dispatch("LMUAddressBookController/getItems", { page: 1, limit: 1000, filter: { email: search, or: true, display_name: search, contact_name: 'LMU', contract_id: this.form.contract_id }})
                        .then(response => {
                            this.addrbook.data = response.items.map(function(item) {
                                return {
                                    id: item.id,
                                    name: item.display_name,
                                    email: item.email,
                                }
                            });
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            getEventsTrigger() {
                if ( this.form.contract_id ) {
                    this.loadingItem = true
                    this.$store.dispatch("NotificationTemplateController/getEventsTrigger", {
                        page: 1,
                        limit: -1,
                        filter: {
                            contract_id: this.form.contract_id,
                        }
                    })
                    .then(response => {
                        this.event_trigger_options = response.data.data.items.map(function(item) {
                            return {
                                id: item.id,
                                module: item.module,
                                name: item.name,
                                description: item.description,
                            }
                        });
                        this.loadingItem = false
                    })
                    .catch(err => {
                        this.event_trigger_options = []
                        this.loadingItem = false
                    })
                }
            },
            changeRepeatEnd(val) {
                if(!val) return
                if(val == 'by date') this.form.repeat_end_times = null
                if(val == 'by time') this.form.repeat_end_datetime = null
            }
        }
    }
</script>
